var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M338 226l25-75c5-16 19-26 35-26h203c16 0 31 10 36 26l25 75h176c20 0 37 17 37 38 0 20-17 37-37 37h-33l-27 468c-4 60-53 106-113 106H334c-60 0-109-46-112-106l-28-468h-31c-21 0-38-17-38-37 0-21 17-38 38-38h175zm79 0h166l-9-26H425l-8 26zm313 75H269l28 464c1 19 17 35 37 35h331c20 0 37-16 38-35l27-464zm-166 95c1-20 19-36 39-35 21 2 37 19 36 40l-17 270c-2 21-19 36-40 35s-37-19-35-40l17-270zM453 666c1 21-15 39-35 40-21 1-39-14-40-35l-17-270c-1-21 14-38 35-40 21-1 39 15 40 35l17 270z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrash);
export default __webpack_public_path__ + "static/media/ic_trash.9227ec57ec79b51ec81e6aa1f1981e64.svg";
export { ForwardRef as ReactComponent };